module.exports = __webpack_public_path__ + "static/media/hubspot-icon.9e71f64b.svg";